import sprites from './sprites.json';

import {removeTrademarkFromAssets} from '@repo/scratch-mod';

export default removeTrademarkFromAssets('sprites', sprites);
